
import React from "react";
import { Button } from "@/components/ui/button";
import { ToastActionElement } from "@/components/ui/toast";

interface ToastButtonProps {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
}

export function useToastAction() {
  const createToastAction = ({ label, onClick, icon }: ToastButtonProps): ToastActionElement => {
    const buttonContent = (
      <>
        {icon}
        {label}
      </>
    );

    return (
      <Button 
        variant="default" 
        size="sm" 
        onClick={onClick}
        className={icon ? "gap-2" : ""}
      >
        {buttonContent}
      </Button>
    );
  };

  return { createToastAction };
}
